import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TrackEditor } from "./TrackEditor";
import { t } from "@/i18n";

const names = (list) => (list || []).map((n) => n.trim()).filter(Boolean);

export const newTrack = (rel) => ({
  id: crypto.randomUUID(), title: "", version: "", isrc: "", audio_language: "es", explicit: false, lyrics: "",
  audio_file_id: null, audio_filename: null, contributors: [],
  artists: [...names(rel.primary_artists).map((name) => ({ name, role: "Primary Artist" })), ...names(rel.featured_artists).map((name) => ({ name, role: "Featured Artist" }))],
  publisher: "", copyright_year: new Date().getFullYear(), copyright_holder: "Doble R Records",
});

export const StepTracks = ({ rel, set }) => {
  const update = (i, t) => set({ tracks: rel.tracks.map((x, j) => (j === i ? t : x)) });
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-display font-semibold">{t("Tracks")}</h3>
          <p className="text-sm text-muted-foreground">{t("{n} track(s) · {rule}", { n: rel.tracks.length, rule: t(rel.release_type === "Single" ? "un Single admite 1–3 tracks" : rel.release_type === "EP" ? "un EP admite 4–6 tracks" : "sin límite") })}</p>
        </div>
        <Button type="button" variant="outline" onClick={() => set({ tracks: [...rel.tracks, newTrack(rel)] })} data-testid="btn-add-track" className="gap-2"><Plus className="h-4 w-4" /> {t("Agregar track")}</Button>
      </div>
      {rel.tracks.length === 0 && <div className="panel p-10 text-center text-sm text-muted-foreground" data-testid="tracks-empty">{t("Agrega al menos un track para continuar.")}</div>}
      {rel.tracks.map((t, i) => <TrackEditor key={t.id} track={t} index={i} onChange={(nt) => update(i, nt)} onRemove={() => set({ tracks: rel.tracks.filter((_, j) => j !== i) })} />)}
    </div>
  );
};
